import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-Sort",
  "use": "svg-icon-Sort-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"svg-icon-Sort\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h12v12H0z\" /><path fill=\"#000\" fill-rule=\"nonzero\" d=\"M5.494 7.794l-1.84-1.84a.5.5 0 0 0-.707.707L5.605 9.32a.505.505 0 0 0 .797 0L9.06 6.661a.5.5 0 0 0-.707-.707l-1.86 1.86V3a.5.5 0 1 0-1 0v4.793z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol